import * as types from '../constants/actionTypes';
import BoostService from '../services/boostServices';
import { updateConversationUserBoostExpiryTime } from './conversationInboxAction';
import { getCreditsPurchase } from './paymentGatewayActions';
import { getUserSettings, updateLoginState } from './loginActions';
import moment from 'moment';
import { Dispatch } from 'redux';
import { IAction } from '../interfaces/IAction';
import { IApiResponse } from '../interfaces/IApiResponse';
import { IConsumable, IConsumableExpiry } from '../interfaces/IConsumable';
import boostServices from 'redhotpie-shared-lib/services/boostServices';
import { addPrefixAndSuffix } from 'redhotpie-shared-lib/functions/messageUtils';
import { IConversation } from 'redhotpie-shared-lib/interfaces/IConversation';
import { IInviteCredit } from 'redhotpie-shared-lib/models/consumable';

export function updateProfileBoostProduct(product: IConsumable[] | undefined): IAction {
  return { type: types.UPDATE_PROFILE_BOOST_PRODUCTS, product };
}

export function updateConversationBoostProduct(product: IConsumable[] | undefined): IAction {
  return { type: types.UPDATE_CONVERSATION_BOOST_PRODUCTS, product };
}

export function updateGenderTypeChangeProduct(product: IConsumable[] | undefined): IAction {
  return { type: types.UPDATE_GENDER_TYPE_CHANGE_PRODUCTS, product };
}

export function updateLikeProducts(product: IConsumable[] | undefined): IAction {
  return { type: types.UPDATE_LIKE_PRODUCTS, product };
}

export function updateFavProducts(product: IConsumable[] | undefined): IAction {
  return { type: types.UPDATE_FAV_PRODUCTS, product };
}

export function updateInvitesCreditProduct(product: IConsumable[] | undefined): IAction {
  return { type: types.UPDATE_INVITES_CREDIT_PRODUCTS, product };
}

export function updateUserRemainingInvitesCredit(data: any): IAction {
  return { type: types.UPDATE_USER_REMAINING_INVITES_CREDIT, data };
}

export function getUserRemainingInvitesCredit() {
  return (dispatch: Dispatch<IAction>) => {
    return BoostService.getUserRemainingInvitesCredit().then((res: IApiResponse<IInviteCredit>) => {
      dispatch(updateUserRemainingInvitesCredit(res.data));
      return res;
    });
  };
}

export function getListInvitesCreditProducts() {
  return (dispatch: Dispatch<IAction>) => {
    return BoostService.getListInvitesCreditProducts().then((res: IApiResponse<IConsumable[]>) => {
      if (res?.success) {
        let product = res.data;
        dispatch(updateInvitesCreditProduct(product));
      }
      return res;
    });
  };
}

export function getListProfileBoostProducts() {
  return (dispatch: Dispatch<IAction>) => {
    return BoostService.getListProfileBoostProduct().then((res: IApiResponse<IConsumable[]>) => {
      if (res?.success) {
        let product = res.data;
        dispatch(updateProfileBoostProduct(product));
      }
      return res;
    });
  };
}

export function getListConversationBoostProduct() {
  return (dispatch: Dispatch<IAction>) => {
    return BoostService.getListConversationBoostProduct().then((res: IApiResponse<IConsumable[]>) => {
      if (res?.success) {
        let product = res.data;
        dispatch(updateConversationBoostProduct(product));
      }
      return res;
    });
  };
}

export function getGenderTypeChangeProduct() {
  return (dispatch: Dispatch<IAction>) => {
    return BoostService.getGenderTypeChangeProduct().then((res: IApiResponse<IConsumable[]>) => {
      if (res?.success) {
        let product = res.data;
        dispatch(updateGenderTypeChangeProduct(product));
      }
      return res;
    });
  };
}

export function purchaseConsumableProduct(consumablePriceID: string, metaData?: any, convId?: number) {
  return (dispatch: any, getState: any) => {
    const { userId, lastBoostedConversationTime } = getState().loginReducer.userInfo;
    const data: IConversation[] = getState().conversationsReducer.data || [];
    const conversationInfo = data.find(x => x.id === convId);
    return BoostService.purchaseConsumableProduct(consumablePriceID, metaData).then((res: IApiResponse<IConsumableExpiry>) => {
      if (res?.success) {
        if (res.data?.boostExpiry) {
          if (convId && metaData) {
            const boostExpiryTime = moment(res.data.boostExpiry).unix() * 1000;
            dispatch(updateConversationUserBoostExpiryTime(convId, boostExpiryTime));

            if (conversationInfo && conversationInfo.peerVcard) {
              boostServices
                .notifyBoostMySelf({
                  fromUserId: `${userId}`,
                  fromUserJid: addPrefixAndSuffix(userId),
                  toUserId: `${userId}`,
                  type: 'Boosting',
                  action: {
                    name: 'BoostMySelf',
                  },
                  data: {
                    status: {
                      userBoostExpiryAt: boostExpiryTime,
                      convId: convId,
                    },
                  },
                })
                .then(res => {
                  console.log('res', res);
                });
            }
          }
        }
        dispatch(getCreditsPurchase());
        dispatch(getUserSettings());
        if (convId && conversationInfo?.peerVcard?.userId) {
          dispatch(
            updateLoginState({
              key: ['userInfo', 'lastBoostedConversationTime'],
              value: { ...lastBoostedConversationTime, [conversationInfo.peerVcard.userId]: new Date().getTime() },
            })
          );
        }
      }
      return res;
    });
  };
}

export function getLikeProducts() {
  return (dispatch: Dispatch<IAction>) => {
    return BoostService.getLikeProducts().then((res: IApiResponse<IConsumable[]>) => {
      if (res?.success) {
        let product = res.data;
        dispatch(updateLikeProducts(product));
      }
      return res;
    });
  };
}

export function getFavProducts() {
  return (dispatch: Dispatch<IAction>) => {
    return BoostService.getFavProducts().then((res: IApiResponse<IConsumable[]>) => {
      if (res?.success) {
        let product = res.data;
        dispatch(updateFavProducts(product));
      }
      return res;
    });
  };
}
